import axios from 'axios'

const http = axios.create({
  baseURL: '/api/v1',
  timeout: 30_000,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

let onUnauthorized = null

export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    if (status === 401 && typeof onUnauthorized === 'function') {
      try {
        onUnauthorized(error)
      } catch (_) {
        // глушим — главное вернуть исходную ошибку наверх
      }
    }
    return Promise.reject(error)
  },
)

export default http
